import $ from 'jquery'

function softUpdate($element, options) {

  function init() {
    if (options.onInit) { options.onInit(); }
    bindDomEvents();
  }

  function bindDomEvents() {
    if(typeof(options.onEvent) !== 'undefined'){
      $('body').on(options.onEvent, options.selector, function(event) {
        event.preventDefault();
        var $target = $(this);
        send($target.attr('href') || $target.attr('action'), $target.serialize() || {});
      });
    }
  }

  function send(url, data) {
    var commonCallback = function(resp) {
      if (options.afterSuccess) { options.afterSuccess(resp); }
    };

    var xhrData = {
      url: url,
      type: 'put',
      dataType: 'json',
      data: data
    },
    callbacks = {
      afterSuccess: function(resp) { commonCallback(resp); },
      afterError: function() { commonCallback(); return false; }
    };

    SOPHIA.sendXHR(xhrData, callbacks);
  }

  // run constructor
  init();

  // PUBLIC METHODS
  return {
    send: function(url, data) {
      send(url, data);
    }
  };
};

// jQuery plugin method
$.fn.softUpdate = function(options) {
  return this.each(function() {
    var $this = $(this);

    // If not already stored, store plugin object in this element's data
    if (!$this.data('softUpdate')) {
      $this.data('softUpdate', new softUpdate($this, options));
    }
  });
};
